import { lazy } from "react";

export const PageAdminConfig = lazy(() => import("./Form"));
